<div class="version-banner">
  <div class="version-banner-content">
    <span class="version-banner-text">A new version is available.</span>
    <button class="version-banner-btn refresh" (click)="onRefresh()">Refresh</button>
    <button class="version-banner-btn close" (click)="onDismiss()" aria-label="Close">&#x2715;</button>
  </div>
</div>
